import http from './http';

export async function deleteArticleService(id) {
	return http.post('/admin/article/delete', { id })
}
